import { FormControl, MenuItem, Select, SelectChangeEvent, Tooltip } from "@mui/material";
import { ReactComponent as ArrowDown } from "assets/ArrowDown.svg";
import { ReactComponent as FileIcon } from "assets/FileIcon2.svg";
import { ReactComponent as Info } from "assets/Info.svg";
import ThemeContext from "components/app/Context";
import Typography from "components/common/Typography";
import Calender from "components/common/calender/Calender";
import { isEmpty } from "lodash";
import React, { useContext } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import colors from "styles/Colors";
import { tokens } from "styles/Tokens";
import { getUIFormatDate } from "utils/DateHelper";
import { setPayloadData } from "../ManageSuggestions.slice";
import "./assignmentDetails.scss";

interface AssignmentDetailsProps {
  isEdit?: boolean;
}

const AssignmentDetails = (props: AssignmentDetailsProps) => {
  const { isMobileScreen } = useContext(ThemeContext);
  const dispatch = useAppDispatch();
  const SelectStyles = {
    height: "44px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: tokens.Text.General.Secondary,
    fontWeight: "inherit",
    fontSize: "14px",
    boxShadow: "none",
    borderRadius: "8px",
    ".MuiSelect-icon": { alignSelf: "center", top: "45%" },
    border: `1px solid ${tokens.Border.General.Tertiary}`,

    ".MuiOutlinedInput-notchedOutline": {
      border: "none"
    }
  };
  const {
    payloadData: { plans }
  } = useAppSelector((state) => state.manageSuggestions);

  const { isEdit } = props;

  const handleChange = (event: SelectChangeEvent, index: number, id: string) => {
    const data: any = plans?.map((plan: any) => {
      if (id === plan.id) return { ...plan, priority: event.target.value };
      return plan;
    });
    dispatch(setPayloadData({ plans: data }));
  };

  const addDueDate = (id: any, date: any) => {
    if (plans) {
      const data: any = plans?.map((plan: any) => {
        if (id === plan.id) return { ...plan, expiryDate: date };
        return plan;
      });
      dispatch(setPayloadData({ plans: data }));
    }
  };

  return (
    <div className="assignent-details-component">
      <div className="sub-heading">
        <Typography variant="h5" color={tokens.Text.General.PrimaryHeadline}>
          {isEdit ? "Define suggestions details" : "Confirm Suggestions"}
        </Typography>
      </div>
      <div className="assignent-details-table-content">
        <div className="main-table">
          <div className="table-heading">
            <div className="priority-container">
              <Typography variant="body2" color={tokens.Text.General.Secondary} showBold>
                Priority
              </Typography>
              <Tooltip
                arrow={true}
                placement={"top"}
                title={
                  <div>
                    <div>
                      <Typography variant="label">
                        <b>Top</b> - Above all Suggested Plans
                      </Typography>
                    </div>
                    <Typography variant="label">
                      <b>Bottom</b> - Below the Custom Suggestions
                    </Typography>
                  </div>
                }
              >
                <Info />
              </Tooltip>
            </div>
          </div>
          <div className="table-heading">
            <Typography variant="body2" color={tokens.Text.General.Secondary} showBold>
              Selected Plan
            </Typography>
          </div>
          <div className="table-heading">
            <Typography variant="body2" color={tokens.Text.General.Secondary} showBold>
              <span style={{ color: colors.Red.Red700 }}>*</span>Expiration Date
            </Typography>
          </div>
          {plans?.length > 0 &&
            plans.map((plan: any, index: number) => {
              const priority = isEmpty(plan?.priority) ? "Bottom" : plan?.priority;
              return (
                <React.Fragment key={plan.id}>
                  <div className="first-heading">
                    <Typography variant="body2" color={tokens.Text.General.Secondary} showBold className="helper-text">
                      Priority
                    </Typography>
                    <div className="column-content">
                      {isEdit ? (
                        <FormControl className="priority-level-formcontrol">
                          <Select
                            sx={SelectStyles}
                            value={priority}
                            onChange={(e: any) => handleChange(e, index, plan.id)}
                            IconComponent={ArrowDown}
                          >
                            <MenuItem value="Top">Top</MenuItem>
                            <MenuItem value="Bottom">Bottom</MenuItem>
                          </Select>
                        </FormControl>
                      ) : (
                        <div>
                          <Typography variant="body2" color={tokens.Text.Feedback.Neutral}>
                            {priority}
                          </Typography>
                        </div>
                      )}
                    </div>
                  </div>
                  <div>
                    <Typography variant="body2" color={tokens.Text.General.Secondary} showBold className="helper-text">
                      Selected plan
                    </Typography>
                    <div className="column-content">
                      <div className="plan-name-with-icon">
                        <FileIcon />
                        <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline} className="ellipse-two">
                          {plan.name}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  <div>
                    <Typography variant="body2" color={tokens.Text.General.Secondary} showBold className="helper-text">
                      <span style={{ color: "red" }}>*</span>Expire date
                    </Typography>
                    <div className="column-content">
                      {isEdit ? (
                        <Calender
                          sx={{ marginLeft: isMobileScreen ? "0px" : "70px", width: isMobileScreen ? "100%" : "auto" }}
                          showLable={false}
                          buttonView={false}
                          defaultValue={plan?.expiryDate}
                          onChange={(val: any) => addDueDate(plan.id, val)}
                        />
                      ) : (
                        <div>
                          {isEmpty(getUIFormatDate(plan?.expiryDate)) ? "-" : getUIFormatDate(plan?.expiryDate)}
                        </div>
                      )}
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default AssignmentDetails;
